import * as React from 'react';
const SvgArrowRed = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 10, height: 16, fill: "none" }, props),
    React.createElement("path", { stroke: "#FA667C", strokeWidth: 2, d: "M8.75 14.856 2 7.928 8.75 1" })));
export default SvgArrowRed;
